import { onAuthStateChanged } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';
import app, { auth, functions } from '../../../config/firebase-config';
import { createCatalogueCache, isAuthorizationError } from './catalogueCache';

const storage = {
  getItem: (key) => window.localStorage.getItem(key),
  setItem: (key, value) => window.localStorage.setItem(key, value),
  removeItem: (key) => window.localStorage.removeItem(key),
};
const options = {
  storage,
  storageKey: `autoapp:vehicle-catalogue:v1:${app.options.projectId}`,
  onError: (error) => console.warn('No se pudo actualizar la caché del catálogo:', error.code || error.message),
};
const privateCache = createCatalogueCache({ ...options,
  storageKey: `${options.storageKey}:authenticated`, getScope: () => auth.currentUser?.uid });
const publicCache = createCatalogueCache({ ...options,
  storageKey: `${options.storageKey}:public`, getScope: () => 'brands' });
let previousUid = auth.currentUser?.uid;
onAuthStateChanged(auth, (user) => {
  if (user?.uid !== previousUid) privateCache.reset();
  previousUid = user?.uid;
});

export async function getCatalogue(kind, ids, endpoint, payload, cacheOptions, isPublic = false) {
  try {
    return await (isPublic ? publicCache : privateCache).get(kind, ids, async () => {
      const result = await httpsCallable(functions, endpoint)(payload);
      return result.data;
    }, cacheOptions);
  } catch (error) {
    if (isAuthorizationError(error)) throw error;
    console.error('Error obteniendo catálogo de vehículos:', error);
    return [];
  }
}
